module.exports = ".hidden {\n  display: none;\n  visibility: hidden; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/employment-training-retention/employment-training-retention.component.scss
// module id = ./src/app/employment-training-retention/employment-training-retention.component.scss
// module chunks = main